<template>
  <article class="course-info">
    <el-tabs v-model="TabActive" type="card">
      <!-- 課程資訊 -->
      <el-tab-pane
        v-if="this.learning"
        :label="$t('course.tab.info')"
        name="classInfo"
      >
        <div class="course-info__content">
          <div class="course-info__grid">
            <div
              v-for="item in CourseInfoList"
              :key="item.title"
              class="course-info__item"
            >
              <div class="course-info__label">
                {{ item.title }}
              </div>
              <div class="course-info__value">
                {{ item.value }}
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <!-- 課程介紹 -->
      <el-tab-pane :label="$t('course.tab.introduction')" name="classDes">
        <div class="course-info__content">
          <div class="course-info__description">
            <pre v-html="courseInfo.courseContent" class="course-info__pre" />
          </div>
        </div>
      </el-tab-pane>

      <!-- 課程講師 -->
      <el-tab-pane :label="$t('course.tab.teacher')" name="classTeacher">
        <div class="course-info__content">
          <div class="course-info__teacher">
            <div
              :class="[
                'course-teacher',
                courseInfo.teacher.teacherImagePathl ? 'course-teacher--has-image' : ''
              ]"
            >
              <div
                v-if="courseInfo.teacher.teacherImagePathl"
                class="course-teacher__image"
              >
                <img :src="courseInfo.teacher.teacherImagePathl" alt="">
              </div>

              <div class="course-teacher__content">
                <div class="course-teacher__name">
                  {{ courseInfo.teacher.teacherName }}
                </div>

                <div class="course-teacher__section">
                  <div class="course-teacher__section-title">
                    {{ $t('course.label.teacherIntro') }}
                  </div>
                  <div
                    class="course-teacher__section-content"
                    v-html="courseInfo.teacher.teacherContent"
                  />
                </div>

                <div class="course-teacher__section">
                  <div class="course-teacher__section-title">
                    {{ $t('course.label.teacherExperience') }}
                  </div>
                  <div
                    class="course-teacher__section-content"
                    v-html="courseInfo.teacher.teacherExperience"
                  />
                </div>
              </div>
            </div>

            <div
              v-if="courseInfo.teacher.teacherYoutubeUrl"
              class="course-teacher__video"
            >
              <div class="course-teacher__video-wrapper">
                <iframe
                  class="course-teacher__video-iframe"
                  :src="
                    `https://www.youtube.com/embed/${ courseInfo.teacher.teacherYoutubeUrl }?rel=0&controls=1&enablejsapi=1&origin=http%3A%2F%2Fkai-tech.com.tw&widgetid=3`
                  "
                  frameborder="0"
                  allowTransparency="true"
                  allowfullscreen
                />
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <!-- 課程明細 -->
      <el-tab-pane :label="$t('course.tab.details')" name="classDetail">
        <div class="course-info__content">
          <!-- 課程明細-精選/自選課程 -->
          <template v-for="classItem in ClassInfoList">
            <div
              :key="classItem.title"
              class="course-info__section"
            >
              <h3 class="course-info__section-title">
                {{ classItem.title }}
              </h3>

              <el-table
                :data="classItem.list"
                border
                class="course-info__table"
              >
                <el-table-column
                  prop="groupName"
                  :label="$t('course.label.subject')"
                  min-width="150"
                />

                <el-table-column
                  v-if="learning || classItem.title === courseInfoLabels.selectedCourses"
                  :label="$t('course.label.lessons')"
                  width="150"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ $t('course.label.total') }} {{ scope.row.buyCourseClassRoomList.length }} {{ $t('course.label.lessonsUnit') }}
                  </template>
                </el-table-column>

                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table
                      :data="props.row.buyCourseClassRoomList"
                      border
                      class="course-info__nested-table"
                    >
                      <el-table-column
                        prop="className"
                        :label="$t('course.label.name')"
                        min-width="200"
                      />

                      <el-table-column
                        prop="teacherName"
                        :label="$t('course.label.teacher')"
                        width="150"
                      />

                      <el-table-column
                        v-if="learning"
                        :label="$t('course.label.supplement')"
                        width="100"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <a
                            v-if="scope.row.classLecturePath"
                            :href="scope.row.classLecturePath"
                            target="_blank"
                            class="course-info__download-link"
                          >
                            <i class="fa fa-download" aria-hidden="true" />
                          </a>
                          <span v-else>-</span>
                        </template>
                      </el-table-column>

                      <el-table-column
                        v-if="learning"
                        :label="$t('course.label.notes')"
                        width="100"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <a
                            v-if="scope.row.classNotePath"
                            :href="scope.row.classNotePath"
                            target="_blank"
                            class="course-info__download-link"
                          >
                            <i class="fa fa-download" aria-hidden="true" />
                          </a>
                          <span v-else>-</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>

          <!-- 課程明細-練習題 -->
          <!-- <div
            v-if="courseInfo.practiceSubjectList"
            class="course-info__section"
          >
            <h3 class="course-info__section-title">{{ $t('course.label.practice') }}</h3>

            <el-table
              :data="courseInfo.practiceSubjectList"
              border
              class="course-info__table"
            >
              <el-table-column
                prop="subJectName"
                :label="$t('course.label.subject')"
                min-width="150"
              />
            </el-table>
          </div> -->
        </div>
      </el-tab-pane>
    </el-tabs>
  </article>
</template>

<script>
import { GetNovicesByMode } from '@/api/Novices';

export default {
  props: ['courseInfo', 'learning'],
  data() {
    return {
      noviceContent: '',
      TabActive: this.learning ? 'classInfo' : 'classDes',
      courseInfoLabels: {},
    };
  },
  created() {
    this.courseInfoLabels = {
      courseName: this.$t('course.label.courseName'),
      examName: this.$t('course.label.examName'),
      categoryName: this.$t('course.label.categoryName'),
      roomName: this.$t('course.label.roomName'),
      viewPeriod: this.$t('course.label.viewPeriod'),
      subject: this.$t('course.label.subject'),
      totalLessons: this.$t('course.label.totalLessons'),
      lessonsUnit: this.$t('course.label.lessonsUnit'),
      selectedCourses: this.$t('course.label.selectedCourses'),
      // optionalCourses: this.$t('course.label.optionalCourses'),
    };
  },
  computed: {
    optionalClassInfo() {
      if (this.courseInfo.courseType === 2) {
        return this._.chain(this.courseInfo.optionalClassRoomList)
          .map((item) => item.optionalClassRoomList)
          .flatten()
          .value();
      }

      return [];
    },
    CourseInfoList() {
      try {
        let allSubject = this._.map(this.courseInfo.classRoomList, 'subjectName');
        let classCount = this._.reduce(
          this.courseInfo.classRoomList,
          (sum, item) => sum + item.buyCourseClassRoomList.length, 0,
        );

        if (this.courseInfo.courseType === 2) {
          allSubject.push(...this._.flatMap(this.courseInfo.optionalClassRoomList,
            (item) => item.optionalClassRoomList.map((item2) => item2.subjectName)));
          // allSubject.push(...this.courseInfo.optionalClassRoomList
          //   .map((item) => item.optionalSubjectName));

          classCount += this._.reduce(
            this.optionalClassInfo,
            (sum, item) => sum + item.buyCourseClassRoomList.length, 0,
          );
        }
        allSubject = this._.chain(allSubject).uniqBy().join('， ');

        return [
          { title: this.courseInfoLabels.courseName, value: this.courseInfo.courseName },
          { title: this.courseInfoLabels.examName, value: this.courseInfo.examName },
          { title: this.courseInfoLabels.categoryName, value: this.courseInfo.categoryName },
          { title: this.courseInfoLabels.roomName, value: this.courseInfo.roomName },
          { title: this.courseInfoLabels.viewPeriod, value: `${this.convertDate(this.courseInfo.courseViewStartDate)} 至 ${this.convertDate(this.courseInfo.courseViewEndDate)}` },
          { title: this.courseInfoLabels.subject, value: allSubject },
          // { title: '課程類型', value: `${this.courseInfo.courseTypeName}課程` },
          { title: this.courseInfoLabels.totalLessons, value: `${classCount}${this.courseInfoLabels.lessonsUnit}` },
        ];
      // eslint-disable-next-line no-unreachable
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);

        return [];
      }
    },
    ClassInfoList() {
      const list = [];

      if (this.courseInfo?.classRoomList?.length) {
        list.push({
          title: this.courseInfoLabels.selectedCourses,
          list: this._.cloneDeep(this.courseInfo.classRoomList),
        });
      }

      // if (this.optionalClassInfo.length) {
      //   list.push({
      //     title: this.courseInfoLabels.optionalCourses,
      //     list: this._.cloneDeep(this.optionalClassInfo),
      //   });
      // }

      return list;
    },
  },
  methods: {
    convertDate(date) {
      return !date ? '' : this.$moment.utc(date).tz('Asia/Taipei').format('YYYY-MM-DD');
    },
    GetNovicesByMode() {
      const modelId = 5;
      GetNovicesByMode(modelId).then((response) => {
        if (response.data.statusCode === 0) {
          this.noviceContent = response.data.data.noviceContent;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.course-info {
  width: 100%;
  margin-top: 0;

  /deep/ .el-tabs {
    &__header {
      margin-bottom: 0;
    }

    &__nav-scroll {
      @media (max-width: 991px) {
        overflow-x: auto !important;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
          height: 6px;
        }
        &::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 3px;
        }
      }
    }

    &__nav {
      background-color: #FBFBFB;

      &-wrap {
        &::after{
          display: none;
        }

        @media (max-width: 991px) {
          &.is-scrollable {
            padding: 0 !important;
          }
        }
      }

      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      width: 100%;
      border: 1px solid rgba(#000, .05);
      border-radius: 4px;

      @media (max-width: 991px) {
        width: max-content;
        min-width: 100%;
      }

      @media (min-width: 992px) {
        overflow: initial;
      }

      &-next, &-prev {
        line-height: 60px;
        color: #000;
        font-size: 15px;

        @media (max-width: 991px) {
          display: none !important;
        }
      }
    }

    &__active-bar {
      display: none;
    }

    &__item {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 150px;
      height: 50px;
      padding: 10px !important;
      font-weight: 500;
      font-size: 15px;
      line-height: 1;
      color: #555;
      text-align: center;

      @media (min-width: 992px) {
        flex: 1;
      }

      @media (max-width: 991px) {
        display: inline-flex;
        min-width: 100px;
        white-space: nowrap;
        flex-shrink: 0;
      }

      &.is-active {
        color: #fff;
        background-color: var(--primary-color);
        border-width: 1px 2px 3px 1px;
        border-style: solid;
        border-color: #A2D7D4;
        border-radius: 4px;
        box-shadow: 0px 0.25px 0.25px rgba(0, 0, 0, 0.15);
      }
    }

    &__content {
      padding: 20px;
      background-color: var(--background-base);
      border: 1px solid #e5e5e5;
      border-top: none;
      border-radius: 0 0 4px;
    }
  }

  // 課程資訊網格
  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;

    @media (max-width: $breakpoint-md) {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }

  &__item {
    padding: 12px 20px;
    background: var(--background-white);
    border-radius: var(--border-radius-base);
    border: 1px solid var(--border-light);
    // border-left: 3px solid var(--info-color);

    @media (max-width: $breakpoint-md) {
      padding: 8px 16px;
    }
  }

  &__label {
    font-size: var(--font-size-sm);
    font-weight: 700;
    color: var(--text-regular);
    margin-bottom: 8px;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    gap: 6px;

    &::before {
      content: '●';
      font-size: 8px;
      color: var(--info-color);
    }
  }

  &__value {
    font-size: var(--font-size-base);
    color: var(--text-primary);
    line-height: 1.7;
    font-weight: 600;
    position: relative;
    z-index: 1;
  }

  // 課程介紹
  &__description {
    padding: 20px;
    background: var(--background-white);
    border-radius: var(--border-radius-base);
    border: 1px solid var(--border-lighter);
  }

  &__pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    color: var(--text-primary);
    font-family: var(--font-family);
    font-size: var(--font-size-base);
    line-height: 1.8;
    margin: 0;
  }

  // 課程明細區塊
  &__section {
    &:not(:first-child) {
      margin-top: 32px;
    }
  }

  &__section-title {
    font-size: var(--font-size-lg);
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 2px solid var(--primary-color);
    font-family: var(--font-family-bold);
    display: inline-block;
  }

  // 表格樣式
  &__table {
    border-radius: var(--border-radius-lg);
    overflow: hidden;

    /deep/ .el-table {
      border-radius: var(--border-radius-lg);

      &__header {
        th {
          background: var(--background-base);
          color: var(--text-primary);
          font-weight: 700;
          font-size: var(--font-size-base);
          padding: 14px 0;
          border-color: var(--border-light);
          text-transform: uppercase;
          letter-spacing: 0.5px;

          &:first-child {
            border-top-left-radius: var(--border-radius-lg);
          }

          &:last-child {
            border-top-right-radius: var(--border-radius-lg);
          }
        }
      }

      &__body {
        td {
          padding: 12px 0;
          font-size: var(--font-size-base);
          color: var(--text-primary);
          font-weight: 500;
          border-color: var(--border-lighter);
        }
      }

      &__row {
        transition: all var(--transition-fast);

        &:hover {
          background-color: var(--primary-light-color);

          td {
            color: var(--text-primary);
          }
        }

        &:nth-child(even) {
          background-color: var(--background-white);
        }
      }

      &__expand-icon {
        color: var(--primary-color);
        font-size: 16px;

        &--expanded {
          color: var(--primary-darken-color);
          transform: rotate(90deg);
        }
      }

      // 邊框樣式
      &::before {
        display: none;
      }

      td,
      th {
        &.is-center {
          text-align: center;
        }
      }
    }
  }

  &__nested-table {
    margin: 16px 24px;
    width: calc(100% - 48px);
    max-width: 100%;

    @media (max-width: $breakpoint-md) {
      margin: 12px 16px;
      width: calc(100% - 32px);
    }

    /deep/ .el-table {
      border: 1px solid var(--border-lighter);
      border-radius: var(--border-radius-base);

      &__header th {
        background: var(--background-base);
        font-size: var(--font-size-sm);
        padding: 10px 0;
      }

      &__body td {
        padding: 10px 0;
        font-size: var(--font-size-sm);
      }

      &__row:hover {
        background-color: var(--primary-light-color);
      }
    }
  }

  &__download-link {
    color: var(--primary-color);
    font-size: var(--font-size-lg);
    transition: all var(--transition-fast);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: var(--border-radius-base);
    background: var(--background-white);

    &:hover {
      color: var(--primary-darken-color);
      transform: scale(1.1);
    }

    i {
      font-size: 16px;
    }
  }
}

// 講師資訊區塊
.course-teacher {
  &--has-image {
    @media (min-width: $breakpoint-md) {
      display: grid;
      grid-template-columns: 280px 1fr;
      gap: 32px;
      align-items: start;
    }
  }

  &__image {
    width: 100%;
    margin-bottom: 24px;

    @media (min-width: $breakpoint-md) {
      margin-bottom: 0;
    }

    img {
      width: 100%;
      border-radius: var(--border-radius-lg);
      transition: transform var(--transition-base);

      &:hover {
        transform: scale(1.02);
      }
    }
  }

  &__content {
    width: 100%;
  }

  &__name {
    font-family: var(--font-family-bold);
    font-size: 24px;
    font-weight: 900;
    line-height: 1.3;
    color: var(--text-primary);
    padding-bottom: 16px;
    border-bottom: 3px solid var(--primary-color);
    display: inline-block;

    @media (max-width: $breakpoint-md) {
      font-size: 20px;
    }
  }

  &__section {
    &:not(:first-child) {
      margin-top: 24px;
    }
  }

  &__section-title {
    position: relative;
    padding-left: 16px;
    font-family: var(--font-family-bold);
    font-size: var(--font-size-lg);
    font-weight: 700;
    color: var(--primary-darken-color);
    margin-bottom: 12px;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      display: block;
      width: 4px;
      height: 20px;
      background: var(--primary-color);
      border-radius: 2px;
    }
  }

  &__section-content {
    white-space: pre-wrap;
    word-wrap: break-word;
    color: var(--text-regular);
    line-height: 1.8;
    font-size: var(--font-size-base);
    padding: 16px;
    background: var(--background-white);
    border-radius: var(--border-radius-base);
    border: 1px solid var(--border-lighter);
  }

  &__video {
    margin-top: 32px;
  }

  &__video-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    border-radius: var(--border-radius-lg);
    background: var(--background-dark);
  }

  &__video-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
